export default [
    {
        path: '/ajuda/manual',
        view: 'ajuda/ajuda/Manual',
        name: 'Manual',
        permissions: ['ADMINISTRADOR', 'GESTOR'],
        breadcrumbs: [
            {
                text: 'Início',
                disabled: false,
                exact: true,
                to: '/dashboard',
            },
            {
                text: 'Manual',
                disabled: true,
                exact: true,
                to: '/ajuda/manual',
            },
        ],
    },
    {
        path: '/ajuda/passo-a-passo',
        view: 'ajuda/ajuda/PassoAPasso',
        name: 'Passo a passo',
        permissions: ['ADMINISTRADOR', 'GESTOR'],
        breadcrumbs: [
            {
                text: 'Início',
                disabled: false,
                exact: true,
                to: '/dashboard',
            },
            {
                text: 'Passo a passo',
                disabled: false,
                exact: true,
                to: '/ajuda/passo-a-passo',
            },
        ],
    },
];
